import Http from "./http";
import { instance2 } from "./http";

const emailAll = async (data:any) =>  {

  try{
        const response = await instance2.post('/favorites/getfavId',  data);
        return response?.data;
  }
  catch(error){
    return error;
  }
}

const emailfieldAll = async (data:any) =>  {

  try{
        const response = await instance2.post('/fields/getemailFieldId',  data);
        return response;
  }
  catch(error){
    return error;
  }
}

export const emailServices = {
  emailAll, emailfieldAll
}